import Icon from "@expo/vector-icons/MaterialCommunityIcons";
import { PurchaseDialog } from "@features/dashboard/components/PurchaseDialog";
import DialogWrapper from "@memorang/ui/src/components/DialogWrapper";
import { useState } from "react";
import { useTranslation } from "react-i18next";
/* -----------------UI--------------- */
import { IconButton, Dialog as PaperDialog } from "react-native-paper";
import SessionConfigContainer from "../containers/SessionConfigContainer";
type Props = {
	visible: boolean;
	handleClose?: () => void;
	selectedTagIds?: number[];
};
export const SessionConfigDialog = ({
	visible,
	handleClose,
	selectedTagIds,
}: Props) => {
	const { t } = useTranslation();

	const [showPurchaseDialog, setShowPurchaseDialog] = useState(false);

	const toggleShowPurchaseDialog = () => {
		setShowPurchaseDialog((prev) => !prev);
	};

	if (showPurchaseDialog) {
		return (
			<PurchaseDialog
				visible={showPurchaseDialog}
				handleClose={() => handleClose?.()}
				productType="STUDY_PACK"
			/>
		);
	}
	return (
		<DialogWrapper visible={visible} handleClose={handleClose}>
			<PaperDialog.Title
				style={{
					textAlign: "center",
				}}
			>
				{t("sessionConfig.title")}
			</PaperDialog.Title>
			<IconButton
				icon={(props) => <Icon name="close" {...props} />}
				onPress={handleClose}
				style={{
					position: "absolute",
					right: 8,
					top: 6,
				}}
			/>
			<PaperDialog.Content
				style={{
					flex: 1,
					paddingBottom: 0,
					paddingHorizontal: 0,
					minHeight: 440,
				}}
			>
				<SessionConfigContainer
					propSelectedTagIds={selectedTagIds}
					toggleShowPurchaseDialog={toggleShowPurchaseDialog}
					handleClose={handleClose}
				/>
			</PaperDialog.Content>
		</DialogWrapper>
	);
};
